export enum ErrorsCode {
    ERR_NOT_FOUND_USER= 'ERR_NOT_FOUND_USER',
    ERR_NOT_FOUND_STORE= 'ERR_NOT_FOUND_STORE',
    ERR_NOT_FOUND_TYPE_ACTIVITY='ERR_NOT_FOUND_TYPE_ACTIVITY',
    ERR_OUT_DATE='ERR_OUT_DATE',
    ERR_EMPTY_DATA='ERR_EMPTY_DATA',
    ERR_FIELDS_ALLOW='ERR_FIELDS_ALLOW',
    VALIDATION_ERROR='VALIDATION_ERROR',
    DUPLICATE_PLACES='DUPLICATE_PLACES'
}